import { useGetAllUsers } from '../../../../hooks/useGetAllUsers';
import { useEffect } from 'react';
import { UserSessionsFilters } from '../../../API/UserSessions/models';

interface UserSelectorProps {
    setFilters: (filters: UserSessionsFilters) => void;
    filters: UserSessionsFilters;
}

export const UserSelector = ({ setFilters, filters }: UserSelectorProps) => {
    const { allUsers, getAllUsers } = useGetAllUsers();

    useEffect(() => {
        getAllUsers();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="mb-2 w-100">
            <div>
                <div className="d-flex flex-column align-items-start">
                    <label htmlFor="creatorFilter" className="text-white mb-1"><small>Seleccionar usuario</small></label>
                    <select
                        id="creatorFilter"
                        className="form-select px-4 rounded py-2"
                        value={filters.userId ? filters.userId : ''}
                        onChange={(e) => { setFilters({ ...filters, userId: e.target.value }) }}
                    >
                        <option className='text-start' key={'todos'} value={''}>Todos</option>
                        {allUsers?.map((user, index) => (
                            <option className='text-start' key={index} value={user.id}>{user.name}</option>
                        ))}
                    </select>
                </div>
            </div>
        </div>
    )
}
